var SimpleCover = require("app/ui/covers/SimpleCover"),
    get         = require("object-path").get,
    kind        = require("enyo/kind");

module.exports = kind(/** @lends  app.ui.covers.PhotoCover.prototype */ {

    /**
     * @private
     */
    name: "app.ui.covers.PhotoCover",

    /**
     * @private
     */
    kind: SimpleCover,

    /**
     * @private
     */
    classes: "app-ui-covers-photo-cover",

    /**
     * Update the component in response to state changes.
     *
     * @public
     */
    update: kind.inherit(function(sup) {
        return function() {
            var authService     = this.app.$.authService,
                userPrivileges  = authService.getUserPrivileges(),
                i18nService     = this.app.$.i18nService,
                data            = this.data || {},
                plan            = get(data, "plan", null),
                title           = get(data, "meta.title", null) || "",
                $premiumOverlay = this.$.premiumOverlay,
                $imageWrapper   = this.$.imageWrapper;

            if (plan === "premium"
                && (userPrivileges.userStatus !== "subscribed"
                || userPrivileges.subscriptionType !== "premium")
            ) {
                $premiumOverlay.show();
            }
            else {
                $premiumOverlay.hide();
            }

            $imageWrapper.set("href", get(data, "links.self", null));
            $imageWrapper.setAttribute("title", i18nService.getString("app.ui.covers.PhotoCover.tooltip", {
                title: title
            }));

            sup.apply(this, arguments);
        };
    })

});
